import { AxiosAuth } from "../axios";
import { AppRoutesApi } from "../../config/appRoutes";
import { ApiSchemaUser } from "../../models/api/apiSchemaUser";
import { ApiResponseContainer } from "../../models/api/apiResponseContainer";
import { showSuccessToast, showErrorToast, showErrorMessageToast } from "../../components/generic/toast.component";

type ChangePasswordType = {
  CurrentPassword: string;
  NewPassword: string;
};

const getUserList = async () => {
  const res = await AxiosAuth.get<ApiResponseContainer<ApiSchemaUser[]>>(AppRoutesApi.User.UserList);
  return res.data;
};
const getUserDataById = async (accountId: string) => {
  const res = await AxiosAuth.get<ApiResponseContainer<ApiSchemaUser>>(AppRoutesApi.User.UserDataById(accountId));
  return res.data;
};

const createUser = async (
  email: string,
  userName: string,
  firstName: string,
  lastName: string,
  companyName: string,
  typeOfCompany: string,
  wtaUserType: string,
  tpaUserType: string,
  paidFeatureSubscriptionType: string,
  phoneNumber: string,
  isPaid: boolean,
  createDate: Date,
  expiryDate: Date,
  expirePeriod: string,
  role: string
) => {
  const body = {
    Email: email,
    UserName: userName,
    FirstName: firstName,
    LastName: lastName,
    CompanyName: companyName,
    TypeOfCompany: typeOfCompany,
    WTAUserType: wtaUserType,
    TPAUserType: tpaUserType,
    paidFeatureSubscriptionType: paidFeatureSubscriptionType, 
    PhoneNumber: phoneNumber,
    IsPaid: isPaid,
    createDate,
    expiryDate,
    expirePeriod,
    role,
  };
  const res = await AxiosAuth.post<ApiResponseContainer<ApiSchemaUser>>(AppRoutesApi.User.UserCreate, body);
  return res.data;
};

const deleteUser = async (accountId: string) => {
  const res = await AxiosAuth.post(AppRoutesApi.User.UserDelete(accountId));
  return res.data;
};

const updateUser = async (
  Id: string,
  firstName: string,
  lastName: string,
  companyName: string,
  typeOfCompany: string,
  wtaUserType: string,
  tpaUserType: string,
  paidFeatureSubscriptionType: string,
  jobTitle: string,
  phoneNumber: string,
  isPaid: boolean,
  createDate: Date,
  expireDate: Date,
  expirePeriod: string
) => {
  const body = {
    Id: Id,
    FirstName: firstName,
    LastName: lastName,
    CompanyName: companyName,
    TypeOfCompany: typeOfCompany,
    WTAUserType: wtaUserType,
    TPAUserType: tpaUserType,
    PaidFeatureSubscriptionType: paidFeatureSubscriptionType,
    JobTitle: jobTitle,
    PhoneNumber: phoneNumber,
    isPaid,
    createDate,
    expireDate,
    expirePeriod,
  };
  const res = await AxiosAuth.post<ApiResponseContainer<ApiSchemaUser>>(AppRoutesApi.User.UserUpdate, body);
  return res.data;
};

const subscribeUser = async (Id: string, IsPaid: boolean) => {
  const body = {
    Id: Id,
    IsPaid: IsPaid,
  };
  const res = await AxiosAuth.post<ApiResponseContainer<ApiSchemaUser>>(AppRoutesApi.User.UserSubscribe(Id), body);
  return res.data;
};

const renewUser = async (Id: string) => {
  const body = {
    Id: Id,
  };
  const res = await AxiosAuth.post<ApiResponseContainer<ApiSchemaUser>>(AppRoutesApi.User.UserRenew(Id), body);
  return res.data;
};

const activateUser = async (Id: string) => {
  const res = await AxiosAuth.post(AppRoutesApi.User.UserActivation(Id));
  return res.data;
};

export const ApiUser = {
  getUserList,
  createUser,
  deleteUser,
  getUserDataById,
  updateUser,
  subscribeUser,
  activateUser,
  renewUser,
};
